module.exports = __webpack_public_path__ + "img/chargingpoint-charging-hub-suggestion.02971a72.png";